import { makeStyles } from "@material-ui/core/styles";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Button, Grid } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";

import Buscador from "../../../../actions/ui/Buscador";
import { fetchSubTipoEfectores } from "../../../../actions/tipoSubtipoEfectores";
import { InsertarEfectorReclamo } from "../../../../actions/reclamos/reclamosActions";

const useStyles = makeStyles({
  botonera: {
    padding: 25,
  },
});

const fechaActual = new Date();

export const AddEfector = (props) => {
  const dispatch = useDispatch();
  const { solicitud, fechaFin, fechaInicio } = props;
  const { areasFisicasUsuario } = useSelector((state) => state.auth);
  const classes = useStyles();
  const [value, setValue] = useState(null);


  const { subtipoEfectores } = useSelector(
    (state) => state.tipoSubtipoEfectores
  );

  useEffect(() => {
    dispatch(fetchSubTipoEfectores());
  }, []);

  const handleSave = () => {
    dispatch(
      InsertarEfectorReclamo(
        solicitud,
        value?.idEfectorFacturacion,
        value.razonSocial,
        areasFisicasUsuario.idArea,
        areasFisicasUsuario.idSubArea,
        fechaInicio,
        fechaFin
      )
    );
    props.cerrarModal();
  };

  return (
    <ValidatorForm onSubmit={handleSave}>
      <Grid container style={{ padding: 25 }}>
        <Grid item xs={12} md={12}>
          <Buscador
            value={value}
            variant="outlined"
            setValue={(val) => setValue(val)}
            label="Razon Social  |  CUIT  |  IdEfector "
            noOptionText={"No se encuentra el efector"}
            endpoint={(texto) =>
              `EfectorFacturacion/Busqueda?parametros=${texto}&todos=${
                props.todos ?? false
              }`
            }
            getOptionLabel={(option) => {
              const subTipoEfector = subtipoEfectores.find(
                (subTipoEfector) =>
                  subTipoEfector.idSubTipoEfector === option.idSubTipoEfector
              )?.descripcionSubTipoEfector;
              return `${option.razonSocial} ${option.cuit} - ${subTipoEfector} -  ${option.efectorDomicilio?.calle} ${option.efectorDomicilio?.nro}`;
            }}
            renderOption={(option) => {
              const subTipoEfector = subtipoEfectores.find(
                (subTipoEfector) =>
                  subTipoEfector.idSubTipoEfector === option.idSubTipoEfector
              )?.descripcionSubTipoEfector;
              return (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span
                    style={{
                      color:
                        option.fechaBaja === null ||
                        option.fechaBaja >= fechaActual.toISOString()
                          ? "green"
                          : "red",
                    }}
                  >{`${option.razonSocial} ${option.cuit} - ${subTipoEfector} -  ${option.efectorDomicilio?.calle} ${option.efectorDomicilio?.nro}`}</span>
                </div>
              );
            }}
          />
        </Grid>
      </Grid>
      <Grid container className={classes.botonera}>
        <Grid item xs={12}>
          <Grid
            container
            spacing={1}
            direction="row"
            justify="flex-end"
            alignItems="center"
          >
            <Button
              variant="contained"
              color="secondary"
              size="small"
              startIcon={<CancelIcon />}
              onClick={props.cerrarModal}
            >
              CANCELAR
            </Button>
            {/* {
                            (validarSoloUnPermiso(permisosUser, permisoAlta) || validarSoloUnPermiso(permisosUser, permisoEdit)) && */}

            <Button
              variant="contained"
              color="primary"
              size="small"
              startIcon={<SaveIcon />}
              type="submit"
              style={{ marginLeft: "0.5rem" }}
              //onClick={props.cerrarModal}
            >
              GUARDAR
            </Button>
            {/* } */}
          </Grid>
        </Grid>
      </Grid>
    </ValidatorForm>
  );
};
